// noinspection ES6UnusedImports

import DowncastWriter from "@ckeditor/ckeditor5-engine/src/view/downcastwriter"
import UpcastWriter from "@ckeditor/ckeditor5-engine/src/view/upcastwriter"
import ViewElement from "@ckeditor/ckeditor5-engine/src/view/element"

/**
 * Sets up a conversion for a custom attribute on view elements contained inside a <figure>.
 *
 * This method:
 * - Adds proper schema rules.
 * - Adds an upcast converter.
 * - Adds a downcast converter.
 */
export function setupVjoonAttributeConversion( viewElementName, modelElementName, attribute, editor, onlyUpcast = false ) {
	// Extend the schema to store an attribute in the model.
	const viewAttribute = createViewAttributeName( attribute );
	const modelAttribute = createModelAttributeName( attribute );

	editor.model.schema.extend( modelElementName, { allowAttributes: [ modelAttribute ] } );

	editor.conversion.for( 'upcast' ).add( upcastAttribute( viewElementName, viewAttribute, modelAttribute ) );
	if( !onlyUpcast ) {
		editor.conversion.for( 'downcast' ).add( downcastAttribute( modelElementName, viewElementName, viewAttribute, modelAttribute ) );
	}
}

export function createViewAttributeName( attribute ) {
	return `data-vjoon-${ attribute }`;
}

export function createModelAttributeName( attribute ) {
	return `vjoon-${ attribute }`;
}

/**
 * Helper method that searches for a given view element in all children of the model element.
 * @param {ViewElement} viewElement
 * @param {String} viewElementName
 * @param {DowncastWriter, UpcastWriter} writer
 * //@param {Writer} writer
 * @return {ViewElement} found view element for viewElementName
 */
export function findViewChild( viewElement, viewElementName, writer ) {
	const viewChildren = Array.from( writer.createRangeIn( viewElement ).getItems() );
	return viewChildren.find( item => item.is( 'element', viewElementName ) );
}

/**
 * Returns the custom attribute upcast converter.
 */
function upcastAttribute( viewElementName, viewAttribute, modelAttribute ) {
	return dispatcher => dispatcher.on( `element:${ viewElementName }`, ( evt, data, conversionApi ) => {
		const viewItem = data.viewItem;
		const modelRange = data.modelRange;

		const modelElement = modelRange && modelRange.start.nodeAfter;

		if (!modelElement ) {
			return;
		}

		conversionApi.writer.setAttribute( modelAttribute, viewItem.getAttribute( viewAttribute ), modelElement );
	} );
}

/**
 * Returns the custom attribute downcast converter.
 */
function downcastAttribute( modelElementName, viewElementName, viewAttribute, modelAttribute ) {
	return dispatcher => dispatcher.on( `insert:${ modelElementName }`, ( evt, data, conversionApi ) => {
		const modelElement = data.item;

		const viewFigure = conversionApi.mapper.toViewElement( modelElement );
		const viewElement = findViewChild( viewFigure, viewElementName, conversionApi.writer );

		if (!viewElement || !modelElement.hasAttribute( modelAttribute )) {
			return;
		}

		conversionApi.writer.setAttribute( viewAttribute, modelElement.getAttribute( modelAttribute ), viewElement );
	} );
}
